/* tslint:disable */
/* eslint-disable */
/**
 * Docusign API
 * Docusign is a service that allows the user to send the documents for signing
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: o365g_ordertakingteam_irssemal@ingka.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateSignRequestDto
 */
export interface UpdateSignRequestDto {
    /**
     * The status of the sign request
     * @type {string}
     * @memberof UpdateSignRequestDto
     */
    status: UpdateSignRequestDtoStatusEnum;
    /**
     * The reason for voiding the sign request
     * @type {string}
     * @memberof UpdateSignRequestDto
     */
    voidedReason: string;
}


/**
 * @export
 */
export const UpdateSignRequestDtoStatusEnum = {
    voided: 'voided',
    unknown_default_open_api: '11184809'
} as const;
export type UpdateSignRequestDtoStatusEnum = typeof UpdateSignRequestDtoStatusEnum[keyof typeof UpdateSignRequestDtoStatusEnum];


/**
 * Check if a given object implements the UpdateSignRequestDto interface.
 */
export function instanceOfUpdateSignRequestDto(value: object): boolean {
    if (!('status' in value)) return false;
    if (!('voidedReason' in value)) return false;
    return true;
}

export function UpdateSignRequestDtoFromJSON(json: any): UpdateSignRequestDto {
    return UpdateSignRequestDtoFromJSONTyped(json, false);
}

export function UpdateSignRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSignRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'voidedReason': json['voidedReason'],
    };
}

export function UpdateSignRequestDtoToJSON(value?: UpdateSignRequestDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'status': value['status'],
        'voidedReason': value['voidedReason'],
    };
}

